/* Assets / my-card-scripts.js */

document.addEventListener('DOMContentLoaded', () => {

  const switchCardColor = (card, swatch) => {
    const color = swatch.dataset.color;
    if (!color) return;

    const variantUrl = swatch.getAttribute('href');
    const variantImageFallback = swatch.dataset.variantImage;

    // A. Update active ring
    const swatches = card.querySelectorAll('.my-swatch');
    swatches.forEach(s => s.classList.remove('is-active'));
    swatch.classList.add('is-active');

    // B. Update links
    const links = card.querySelectorAll('.js-product-link');
    links.forEach(link => link.setAttribute('href', variantUrl));

    // C. Get JSON data safely
    const mediaDataNode = card.querySelector('.card-media-data');
    if (!mediaDataNode) return;
    
    let mediaData =[];
    try {
      mediaData = JSON.parse(mediaDataNode.textContent);
    } catch (err) {
      console.error("Error reading images", err);
      return;
    }

    const targetTag = `%${color.toLowerCase().trim()}%`;
    
    // D. Filter matching images for this color
    const matchingMedia = mediaData.filter(media => {
      const alt = (media.alt || "").toLowerCase();
      return alt.includes(targetTag);
    });

    // Extract the specific %Hover% image, and the normal images
    const hoverMedia = matchingMedia.find(media => {
      const alt = (media.alt || "").toLowerCase();
      return alt.includes('%hover%');
    });

    const normalMedia = matchingMedia.filter(media => {
      const alt = (media.alt || "").toLowerCase();
      return !alt.includes('%hover%');
    });

    const primaryImg = card.querySelector('.my-card__image--primary');
    const secondaryImg = card.querySelector('.my-card__image--secondary');

    if (!primaryImg) return;

    let newPrimaryUrl = '';
    let newSecondaryUrl = '';

    // Assign Primary Url (ignores the %Hover% image so it doesn't accidentally become the main image)
    if (normalMedia.length > 0) {
      newPrimaryUrl = normalMedia[0].url; 
    } else if (matchingMedia.length > 0) {
      newPrimaryUrl = matchingMedia[0].url; // Failsafe
    } else if (variantImageFallback) {
      newPrimaryUrl = variantImageFallback;
    }

    // Assign Secondary Url (prioritizes %Hover% image)
    if (hoverMedia) {
      newSecondaryUrl = hoverMedia.url; // Use specific custom hover
    } else if (normalMedia.length > 1) {
      newSecondaryUrl = normalMedia[1].url; // Fallback to 2nd normal image
    } else if (normalMedia.length > 0) {
      newSecondaryUrl = normalMedia[0].url; // Fallback to 1st image if no others exist
    }

    // --- THE SMOOTH PRELOADER METHOD ---

    // 1. Swap Primary Image Smoothly
    if (newPrimaryUrl && primaryImg.getAttribute('src') !== newPrimaryUrl) {
      const imgPreloader = new Image();
      imgPreloader.onload = () => {
        primaryImg.src = newPrimaryUrl;
        primaryImg.removeAttribute('srcset'); 
      };
      imgPreloader.src = newPrimaryUrl; 
    }

    // 2. Swap Secondary (Hover) Image Smoothly
    if (secondaryImg) {
      if (newSecondaryUrl && secondaryImg.getAttribute('src') !== newSecondaryUrl) {
        
        // INSTANT FIX: Stop the wrong color from flashing while downloading
        if (newPrimaryUrl) {
          secondaryImg.src = newPrimaryUrl;
          secondaryImg.removeAttribute('srcset');
        }

        const hoverPreloader = new Image();
        hoverPreloader.onload = () => {
          secondaryImg.src = newSecondaryUrl; 
          secondaryImg.setAttribute('loading', 'eager'); 
          secondaryImg.style.display = ''; 
        };
        hoverPreloader.src = newSecondaryUrl;
      } else if (!newSecondaryUrl) {
        secondaryImg.style.display = 'none'; 
      }
    }
  };

  // 2. Event Delegation (This stops the redirect!)
  document.body.addEventListener('click', (e) => {
    const swatch = e.target.closest('.my-swatch');
    if (!swatch) return;

    // Stop page from loading the link
    e.preventDefault(); 
    
    const card = swatch.closest('.my-card');
    if (card) {
      switchCardColor(card, swatch);
    }
  });

  // 3. Apply Filter Colors
  const applyUrlFilterColor = () => {
    const params = new URLSearchParams(window.location.search);
    let activeFilterColor = null;
    
    for (const [key, value] of params.entries()) {
      if (key.toLowerCase().includes('color') || key.toLowerCase().includes('colour')) {
        activeFilterColor = value;
        break;
      }
    }

    if (activeFilterColor) {
      const cards = document.querySelectorAll('.my-card');
      cards.forEach(card => {
        const targetSwatch = Array.from(card.querySelectorAll('.my-swatch')).find(s => {
          return s.dataset.color && s.dataset.color.toLowerCase() === activeFilterColor.toLowerCase();
        });
        
        if (targetSwatch) {
          // Only switch if it isn't already active to prevent loop bugs
          if (!targetSwatch.classList.contains('is-active')) {
            switchCardColor(card, targetSwatch);
          }
        }
      });
    }
  };

  applyUrlFilterColor();

  // 4. Watch for Filter AJAX updates
  const gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer) {
    const observer = new MutationObserver(() => {
      setTimeout(applyUrlFilterColor, 50);
    });
    observer.observe(gridContainer, { childList: true, subtree: true });
  }

});